import styled from "styled-components";

export const Container = styled.div`
    position: relative;
`;

export const Button = styled.button`
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    background-color: transparent;
    border-radius: 4px;
    padding: 4px 12px;
    font-weight: 500;

    &:hover{
        background-color: ${(props) => props.theme.colors.primary_low};
    }

    &.button-submit{
        background-color: ${(props) => props.theme.colors.primary};
        color: ${(props) => props.theme.colors.white};
        
        &:hover{
            background-color: ${(props) => props.theme.colors.primary_high};
        }
    }
    
    &.button-cancel{
        color: ${(props) => props.theme.colors.gray.gray_600};
        border: 1px solid ${(props) => props.theme.colors.gray.gray_100};

        &:hover{
            background-color: ${(props) => props.theme.colors.gray.gray_100};
        }
    }
    &.button-close{
        display: flex;
        color: ${(props) => props.theme.colors.gray.gray_600};
    
        &:hover{
            background-color: ${(props) => props.theme.colors.gray.gray_50};
            color: ${(props) => props.theme.colors.primary};
        }
    }
`;

export const Body = styled.div`
    max-height: 350px;
    overflow-y: auto;
    
    @media (max-width: 900px) {
        max-height: 300px;
    }
`;

export const Content = styled.main`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;
    
    display: flex;
    align-items: center;
    justify-content: center;

    pointer-events: none; // This allows clicks to pass through to elements below
  
    & > * {
        pointer-events: auto; // But content inside the container will still receive clicks
    }
`;

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
`;

export const PopUp = styled.div`
    background-color: ${(props) => props.theme.colors.white};
    width: 600px;
    padding: 30px;
    border-radius: 4px;
    
    display: flex;
    flex-direction: column;
    gap: 12px;

    &:active {
        cursor: grabbing;
    }

    @media (max-width: 900px) {
        padding: 20px;
        width: 100%;
        max-width: 95%;
        max-height: 95%;
    }
`;

export const PopHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    color: ${(props) => props.theme.colors.gray.gray_600};
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    padding: 8px 12px;
`;

export const Select = styled.select`
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    padding: 4px 8px;
    width: 100%;
    border-radius: 4px;
    `;

export const Text = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    
    &.label{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;
